import { Injectable } from '@angular/core';
import { OrganizationService } from './organization.service';
import { Router, NavigationExtras } from '@angular/router';
import { DataService } from './data/data.service';

@Injectable()
export class RedirectService {
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(
    private organizationService: OrganizationService,
    private router: Router, private dataService: DataService
  ) { }

  getRedirectUrl() {
    return this.redirectUrl || this.getHomeUrl();
  }

  redirectToParentAccount(parentId: number) {
    this.dataService.getStudentsByParent(parentId).subscribe(parent => {
      if (parent.Students && parent.Students.length === 1) {
        this.navigate(`/parent/students/${parent.Students[0].ID}`);
      }
      else {
        this.navigate(`/parent/account/${parentId}`);
      }
    })
  }

  redirect() {
    this.navigate(this.getRedirectUrl());
    this.redirectUrl = '';
  }

  clearRedirect() {
    this.redirectUrl = '';
  }

  navigate(url: string) {
    let navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
    };
    this.router.navigateByUrl(url, navigationExtras);
  }

  getHomeUrl() {
    return this.organizationService.hasRootAdminOrg() ? `/organizations/${this.organizationService.rootOrgId}` : '/organizations';
  }
}
